import React, { useState, useEffect } from "react";
import { Box, Paper, Typography, Button, TextField, Grid } from "@mui/material";
import { fonts, size, colors } from "../../ColorFont/color";
import { url } from "../../ConstUrl/Url";

const FreePlans = () => {
  const [defaultValues, setDefaultValues] = useState({});
  const [loading, setLoading] = useState(true);
  const [freePlans, setFreePlans] = useState({});

  useEffect(() => {
    const fetchDefaultValues = async () => {
      try {
        const response = await fetch(`${url}/api/default-values`);
        const data = await response.json();
        setDefaultValues(data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchDefaultValues();
    fetchFreePlans();
  }, [freePlans]);

  const fetchFreePlans = async () => {
    try {
      const response = await fetch(`${url}/api/get-default-values`);
      const data = await response.json();
      setFreePlans(data);
    } catch (error) {
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${url}/api/default-values`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(defaultValues),
      });
      const data = await response.json();
      setDefaultValues(data);
    } catch (error) {
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Box sx={{ margin: "14px" }}>
      <Typography
        sx={{
          fontFamily: fonts.poppins,
          fontSize: size.title,
          color: colors.primary_dark,
          fontWeight: 600,
          marginBottom: "20px",
        }}
      >
        Free Plans
      </Typography>

      <Paper sx={{ 
        padding: "24px", 
        borderRadius: 3, 
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
        background: colors.white_bg || "#FFFFFF",
        border: `1px solid ${colors.border}`
      }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Typography sx={{fontFamily:fonts.poppins, fontWeight:600}}>Add No.of Contacts</Typography>
            <TextField
              // label="No of Contacts"
              value={defaultValues.noOfContacts}
              onChange={(e) =>
                setDefaultValues({
                  ...defaultValues,
                  noOfContacts: e.target.value,
                })
              }
              fullWidth
              variant="outlined"
              sx={{
                marginBottom: "16px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "16px", // Adjust this value for the desired border radius
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography sx={{fontFamily:fonts.poppins, fontWeight:600}}>Add No.of Hours</Typography>
            <TextField
              // label="Sponsored Hours"
              value={defaultValues.sponsoredHours}
              onChange={(e) =>
                setDefaultValues({
                  ...defaultValues,
                  sponsoredHours: e.target.value,
                })
              }
              fullWidth
              variant="outlined"
              sx={{
                marginBottom: "16px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "16px", // Adjust this value for the desired border radius
                },
              }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              size="small"
              onClick={handleUpdate}
              sx={{ backgroundImage: colors.button }}
            >
              Update
            </Button>
          </Grid>
        </Grid>

        <Box
          sx={{
            marginTop: "24px",
            paddingTop: "10px",
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            <strong>No of Contacts:</strong> {freePlans.noOfContacts}
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: 500, marginTop: "8px" }}
          >
            <strong>Sponsored Hours:</strong> {freePlans.sponsoredHours}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default FreePlans;
